/* import __COLOCATED_TEMPLATE__ from './voltage-range-details.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();